export default {
    'days': 'Μέρες',
    'weeks': 'Εβδομάδες',
    'months': 'Μήνες'
};